export default {"src":"/_next/static/media/TH_v2.bf0a5f62.svg","height":35,"width":53,"blurWidth":0,"blurHeight":0};